import { MaskedLines, Eyebrow } from "@/components/Reveal";

export default function PageHero({ eyebrow, title, lede, meta }) {
  const lines = Array.isArray(title) ? title : [title];
  return (
    <section className="bg-paper pt-32 sm:pt-40 pb-16 lg:pb-20 border-b border-line relative grain" data-testid="page-hero">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 relative z-10">
        <Eyebrow className="mb-6">{eyebrow}</Eyebrow>
        <h1>
          <MaskedLines
            lines={lines}
            className="font-serif text-4xl sm:text-6xl lg:text-7xl text-ink leading-[1.05] tracking-tight max-w-4xl"
          />
        </h1>
        {lede && <p className="mt-8 text-txtmut text-lg leading-relaxed max-w-2xl">{lede}</p>}
        {meta && <p className="mt-6 font-mono text-xs uppercase tracking-[0.18em] text-txtmut/70">{meta}</p>}
      </div>
    </section>
  );
}
